import { useTranslation } from 'react-i18next';
import logoImage from 'src/assets/images/logo.png';
import smallLogo from 'src/assets/images/fs_secondary_logo_light.png';
import { Box, BoxProps } from '@mui/material';
import { useGlobals } from 'src/shared/contexts/appContext';

const ImgBox = Box as React.ComponentType<BoxProps<'img'>>;

interface Props {
  isSmall: boolean;
}

const LogoImage = ({ isSmall }: Props) => {
  const { t } = useTranslation(['common']);

  const { currentUser, currentMember } = useGlobals();

  const logo = () => {
    if (currentUser && currentUser.logoMediaType && currentUser.logoBase64) {
      return `data:${currentUser.logoMediaType};base64,${currentUser.logoBase64}`;
    }
    if (currentMember && currentMember.logoMediaType && currentMember.logoBase64) {
      return `data:${currentMember.logoMediaType};base64,${currentMember.logoBase64}`;
    }
    return isSmall ? smallLogo : logoImage;
  };

  return (
    <ImgBox
      component='img'
      src={logo()}
      alt={t('common:associationLogo')}
      sx={{
        maxHeight: '1.5rem',
        width: 'auto',
        pl: (thm) => (isSmall ? 0 : thm.spacing(2)),
      }}
    />
  );
};

export default LogoImage;
